<template>
  <div class="column is-12">
    <div class="mb-5">
      <h3>
        {{ $t('settings.campground.logoImage') }}
        <span class="btn btn-primary" @click="toggleImageChange('logo')">
          <i class="fa fa-pencil" />
        </span>
      </h3>
      <ImageSort
        v-if="images.logo.length && !imageChange.logo"
        v-model="images.logo"
        is-single-image
        is-campground-image
        image-type="logo"
      />
      <ImageUpload
        v-else
        hide-title
        is-single-image
        is-campground-image
        image-type="logo"
        @uploaded="uploadedImage('logo', 'logo')"
      />
    </div>

    <div class="mb-5">
      <h3>
        {{ $t('settings.campground.logoBooking') }}
        <span class="btn btn-primary" @click="toggleImageChange('logoBooking')">
          <i class="fa fa-pencil" />
        </span>
      </h3>
      <ImageSort
        v-if="images.logoBooking.length && !imageChange.logoBooking"
        v-model="images.logoBooking"
        is-single-image
        is-campground-image
        image-type="logo_booking"
      />
      <ImageUpload
        v-else
        hide-title
        is-single-image
        is-campground-image
        image-type="logo_booking"
        @uploaded="uploadedImage('logoBooking', 'logo_booking')"
      />
    </div>

    <div class="mb-5">
      <h3>
        {{ $t('settings.campground.logoEmail') }}
        <span class="btn btn-primary" @click="toggleImageChange('logoEmail')">
          <i class="fa fa-pencil" />
        </span>
      </h3>
      <ImageSort
        v-if="images.logoEmail.length && !imageChange.logoEmail"
        v-model="images.logoEmail"
        is-single-image
        is-campground-image
        image-type="logo_email"
      />
      <ImageUpload
        v-else
        hide-title
        is-single-image
        is-campground-image
        image-type="logo_email"
        @uploaded="uploadedImage('logoEmail', 'logo_email')"
      />
    </div>

    <div>
      <h3>
        {{ $t('settings.campground.imagesList') }}
        <span class="btn btn-primary" @click="toggleImageChange('list')">
          <i class="fa fa-pencil" />
        </span>
      </h3>
      <ImageSort
        v-if="images.list.length && !imageChange.list"
        v-model="images.list"
        is-campground-image
        image-type="list"
      />
      <ImageUpload
        v-else
        hide-title
        is-campground-image
        image-type="list"
        @uploaded="uploadedImage('list', 'list')"
      />
    </div>
  </div>
</template>

<script>
    import { ImageSort, ImageUpload } from '../../index';
    import { Api } from '../../../../api';

    export default {
        name: 'ImagesTab',
        components: { ImageSort, ImageUpload },
        data() {
            return {
                images: {
                    logo: [],
                    logoBooking: [],
                    logoEmail: [],
                    list: [],
                },
                imageChange: {
                    logo: false,
                    logoBooking: false,
                    logoEmail: false,
                    list: false,
                },
            };
        },
        async created() {
            // Lade IMMER frisch vom Server, statt auf AppModel zu vertrauen (kann stale sein)
            await this.refreshAllImages();
        },
        methods: {
            async refreshAllImages() {
                try {
                    // Einzel-Logos holen
                    const [logoRes, emailRes, bookingRes, listRes] = await Promise.all([
                        Api.campgroundImages.fetchImages('logo'),
                        Api.campgroundImages.fetchImages('logo_email'),
                        Api.campgroundImages.fetchImages('logo_booking'),
                        Api.campgroundImages.fetchImages('list'),
                    ]);

                    // Helper: robust auf verschiedene Response-Formate reagieren
                    const toSingleArray = (res) => {
                        const d = res && (res.data || res.body || {});
                        if(typeof d === 'string') return [d];
                        if(d && typeof d.url === 'string') return [d.url];
                        // manchmal kommt { data: { url: '...' } }
                        if(d && d.data && typeof d.data.url === 'string') return [d.data.url];
                        return [];
                    };
                    const toListArray = (res) => {
                        const d = res && (res.data || res.body || []);
                        if(Array.isArray(d)) return d;
                        // Fallback: einzelne URL in ein Objekt mit url-Feld hüllen
                        if(typeof d === 'string') return [{ url: d }];
                        if(d && typeof d.url === 'string') return [d];
                        return [];
                    };

                    this.images.logo = toSingleArray(logoRes);
                    this.images.logoEmail = toSingleArray(emailRes);
                    this.images.logoBooking = toSingleArray(bookingRes);
                    this.images.list = toListArray(listRes);

                    // Nach Laden: Bearbeitungs-Modi sicher schließen
                    this.imageChange = { logo: false, logoBooking: false, logoEmail: false, list: false };
                } catch (e) {
                    // Falls ein Call fehlschlägt, zumindest nichts crashen lassen
                    // und vorhandene (ggf. leere) Arrays beibehalten
                    // eslint-disable-next-line no-console
                    console.warn('Failed to refresh campground images', e);
                }
            },
            async uploadedImage(type = 'logo', urlType = 'logo') {
                const img = await Api.campgroundImages.fetchImages(urlType);
                if(type === 'list') {
                    // Liste: erwarte Array von Objekten mit mind. { url }
                    const d = (img && (img.data || img.body)) || [];
                    this.images[type] = Array.isArray(d) ? [...d] : (typeof d === 'string' ? [{ url: d }] : (d && d.url ? [d] : []));
                } else {
                    // Einzel: als Array aus String-URL halten, wie ImageSort es erwartet
                    const d = img && (img.data || img.body);
                    const url = (d && d.url) ? d.url : (typeof d === 'string' ? d : null);
                    this.images[type] = url ? [url] : [];
                }
                this.imageChange[type] = false;
                this.$emit('images-change', { type, images: this.images[type] });
            },
            toggleImageChange(type = 'logo') {
                this.imageChange[type] = !this.imageChange[type];
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/views/components/campground-settings/tabs/ImagesTab.vue